import React from "react"
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap"
import { Category } from "../Categories"
import { useTranslation } from "react-i18next"

const CategoryActionMenu = ({
  category,
  editCategoryHandler,
  viewDetailsHandler,
  deleteCouponHandler,
  addOfferHandler,
  addCompaign,
}: {
  category: Category
  editCategoryHandler: (category: Category) => void
  viewDetailsHandler: (id: number) => void
  deleteCouponHandler: (category: Category) => void
  addOfferHandler: (category: Category) => void
  addCompaign: (category: Category) => void
}) => {
  const { t } = useTranslation()

  return (
    <UncontrolledDropdown>
      <DropdownToggle tag="a" className="card-drop">
        <i className="mdi mdi-dots-vertical font-size-18"></i>
      </DropdownToggle>

      <DropdownMenu className="dropdown-menu-end">
        <DropdownItem onClick={() => editCategoryHandler(category)}>
          <span className="">{t("common_edit")}</span>
        </DropdownItem>
        <DropdownItem onClick={() => viewDetailsHandler(category.id)}>
          <span className="">{t("common_viewDetails")}</span>
        </DropdownItem>
        {/* <DropdownItem onClick={() => addOfferHandler(category)}>
          <span className="">{t("common_addOffer")}</span>
        </DropdownItem>
        <DropdownItem onClick={() => addCompaign(category)}>
          <span className="">{t("common_addCompaign")}</span>
        </DropdownItem> */}
        <DropdownItem onClick={() => deleteCouponHandler(category)}>
          <span className="text-danger">{t("categories_deleteCategory")}</span>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}

export default CategoryActionMenu
